
import { observable } from "mobx";
import { WinningDataInner } from "../WinningDataInner";

/**
* WinningsDataModel defines the input data and status of the winnings for particular event
*
* @typedef WinningsDataModel
* @type {type}
* @property {winnings} Winnings array of objects which contains the winning value and the current status
* @property {branchID} BranchId the id number of the current sport
*/

export class WinningsDataModel {
    @observable winnings:WinningDataInner[]
    branchID: number

    constructor(source) {
        this.winnings = source.winnings;
        this.branchID = source.branchID;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./data/models/WinningsDataModel/WinningsDataModel.ts